module.exports = __webpack_public_path__ + "img/ThaiFlag.62cbd2d5.svg";